import React from 'react'
import { useTranslation } from 'react-i18next';
import ErrorHandler from '../../error-handler/ErrorHandler'
import { APILINK } from '../../EndPoint';
import { Row, Col } from "react-bootstrap";
import ModifiedForm from '../layout/form/ModifiedForm'
import { TextField } from '../layout/form/TextInputFields';
import axiosInstance from '../../api/axiosInstance';

const COMPONENT = "Create-Bank: ";

function CreateJobs() {
    const { t } = useTranslation();

    async function submitJob(data) {
        try {
            const res = await axiosInstance.post("/job", data);
            return { type: 1, message: t("success") }
        }
        catch (e) {
            console.log(e.response);


            return { type: 2, message: e.message }

        }
    }

    return (
        <ModifiedForm
            submitFunction={submitJob}
        >
            <Row>

                <h4 className="title">{t("createJobs")}</h4>

                <Col lg={6}>
                    <TextField
                        className="formTextField"
                        id={"title_ar"}
                        title={t("form.nameAR")}
                    />
                </Col>
                <Col lg={6}>
                    <TextField
                        className="formTextField"
                        id={"title_en"}
                        title={t("form.nameEN")}
                    />
                </Col>
            </Row>


            <div className="formSubmit">
                <button className="defaultButton" type="submit" >
                    {t("buttons.finish")}
                </button>
            </div>
        </ModifiedForm>
    )
}

export default ErrorHandler(CreateJobs, axiosInstance)